// extracted by mini-css-extract-plugin
export default {"section":"HomePage_section__Tc04B"};